import type { RouteListItem } from '@/types';

import type { RevenueLockdownFormSchema } from './revenue-lockdown-form-schema';

import { settingsBcLink } from '../../model';

export const defaultValues: Readonly<RevenueLockdownFormSchema> = {
  id: -1,
  name: null,
  lock_start_date: '',
  lock_end_date: '',
};

export const breadcrumbsLinks: RouteListItem[] = [
  settingsBcLink,
  { path: '/settings/revenue-lockdowns', name: 'Revenue Lockdowns' },
];
